import { log, supabase } from ".";
import { cambioRequiereRecaptura, capturarSnapshotDesdeVenta } from "./comisionSnapshot";

export const updateOportunidad = async ({ id, oportunidad }) => {
  try {
    // Estado previo (para comparar sensibilidad y como base de la re-captura)
    let antes = null;
    try {
      const prev = await supabase.select("sales", { filters: { id } });
      antes = prev && prev[0];
    } catch (prevErr) {
      log.error("updateOportunidad/antes", prevErr);
    }

    const data = await supabase.update("sales", oportunidad, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    // Re-captura ADITIVA: solo si cambió un campo sensible. Si falla, NO aborta el update.
    try {
      if (antes) {
        // Defensa en profundidad: fijar el `id` CONOCIDO (no depender del "antes")
        // → la foto nunca se mis-keyea aunque el "antes" viniera mal.
        const despues = { ...antes, ...oportunidad, id };
        if (cambioRequiereRecaptura(antes, despues)) {
          await capturarSnapshotDesdeVenta(despues, "modificacion");
        }
      }
    } catch (snapErr) {
      log.error("updateOportunidad/snapshot", snapErr);
    }

    return data;
  } catch (error) {
    log.error("updateOportunidad", error);
    throw error;
  }
};
